/* global naja, $, intervalFunction */

class ModalExtension {
    initialize(naja)
    {
        naja.uiHandler.addEventListener('interaction', this.handleInteraction.bind(this));
        naja.addEventListener('complete', this.openModal.bind(this));
    }

    handleInteraction(event)
    {
        const dataModal = event.detail.element.dataset.modal;
        if (dataModal && dataModal !== 'false') {
            event.preventDefault();

            // Create request by hand adn set isModal to true
            naja.makeRequest(
                'GET', event.detail.element.href, {
                    isModal: true
                }
            );
        }
    }

    openModal(event)
    {
        const payload = event.detail.payload || null;
        const addAnotherDeviceModal = document.getElementById('add-another-device');
        if (addAnotherDeviceModal) {
            // pokud je modal v DOMu, otevři ho
            $('#add-another-device').modal('show');
        }
        
        if (payload === null || !payload.hasOwnProperty('modalId')) {
            return;
        }

        const modalId = payload.modalId;
        const showModal = payload.showModal || false;

        if (!showModal) {
            return;
        }

        // nastav kurzor na první input v modalu

        $("#" + modalId).on('shown.bs.modal', function () {
            $(this).find('input:not([type="checkbox"]),textarea').filter(':visible:first').focus();
        });

        document.dispatchEvent(new CustomEvent('modalDialogOpened', {detail: {modalId: modalId}}));

        $("#" + modalId).modal('show');
    }
}

export default ModalExtension;
